import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-save-view-dialog',
    templateUrl: './save-view-dialog.component.html',
    styleUrls: ['./save-view-dialog.component.scss']
})
export class SaveViewDialogComponent implements OnInit{
    viewName: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<SaveViewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
        private builder: FormBuilder) {
        this.viewName = this.builder.group({
            'name': [data.name, [Validators.required, Validators.maxLength(1000)]]
        });
    }

    ngOnInit(): void {}

    cancel(): void {
        this.dialogRef.close(false);
    }

    saveView(): void {
        this.dialogRef.close( this.viewName.get('name').value );
    }

}



// WEBPACK FOOTER //
// ./src/app/form-views/components/data/save-view-dialog/save-view-dialog.component.ts